import React, { memo } from "react";

import { Text, Box, HStack, VStack, Link, Circle } from "@chakra-ui/react";
import colors from "app/colors";
import { LinkFragment } from "gql/graphql";
import { getUserFullName } from "modules/utils/Functions";
import LinkIcon from "modules/icons/link-icon";
import { useUsers } from "modules/providers/users-provider";
import moment from "moment";
import { MESSAGE_CALENDAR_FORMATS } from "modules/utils/Constants";
import MessageLink from "./message-link";
import { OpenInNewIcon } from "modules/icons";

interface IProps {
  link: LinkFragment;
}

const MessageThreadFilesDrawerLink = ({ link }: IProps) => {
  const { usersById } = useUsers();

  const user = usersById[link.userId];

  if (!user) return null;

  return (
    <Box
      h={118}
      alignContent="center"
      w="full"
      borderBottomWidth={1}
      borderBottomColor={colors.gray0}
    >
      <HStack spacing={4} h={86} w="full">
        <Link
          href={link.url}
          isExternal
          borderColor={colors.grayPrimary}
          borderWidth={1}
          borderRadius="6px"
          h={86}
          w={86}
        >
          <LinkIcon fill={colors.gray0} />
        </Link>
        <VStack alignItems="flex-start" h="full" w="full" spacing={0}>
          <Link
            href={link.url}
            color={colors.blue}
            fontSize={16}
            fontWeight={700}
            noOfLines={1}
            wordBreak="break-all"
            isExternal
          >
            {link.url}
          </Link>
          <HStack
            color={colors.gray50}
            fontSize={14}
            fontWeight={400}
            spacing={1}
          >
            <Text>{getUserFullName(user)}</Text>
            <Text>•</Text>
            <Text>
              {moment(link.createTime).calendar(MESSAGE_CALENDAR_FORMATS)}
            </Text>
          </HStack>
          <MessageLink
            messageThreadId={link.messageThreadId}
            messageId={link.messageId}
          />
        </VStack>
        <Box alignItems="flex-start" h="full">
          <Circle bg={colors.gray40} size={8}>
            <Link
              href={link.url}
              color={colors.blue}
              fontSize={16}
              fontWeight={700}
              noOfLines={1}
              wordBreak="break-all"
              isExternal
            >
              <OpenInNewIcon fill={colors.white} />
            </Link>
          </Circle>
        </Box>
      </HStack>
    </Box>
  );
};

export default memo(MessageThreadFilesDrawerLink);
